"use strict";
// Identity 1 of the three a document carries: Foundry's own trade reference. Identity 2 is the
// issuing entity's gap-free legal number, written only at issuance; identity 3 is the
// counterparty's own number, recorded and never adopted as ours.
//
// The ordinal here is deliberately NOT identity 2's machinery and must never borrow it. It carries
// no legal weight, no gap-free guarantee and no uniqueness rule: a deleted draft leaves a hole that
// nothing backfills. Only the gap-free legal number, which the numbering service alone writes at
// issuance, makes those promises.
//
// The format is deterministic from the trade context, so a reader can place a reference without a
// lookup: order, side, document kind, and a per-ledger-per-kind ordinal.
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalReferenceSourceSchema = exports.INTERNAL_REFERENCE_SOURCES = exports.INTERNAL_REFERENCE_PATTERN = exports.INTERNAL_REFERENCE_ORDINAL_DIGITS = void 0;
exports.formatInternalReference = formatInternalReference;
exports.isDerivedInternalReference = isDerivedInternalReference;
exports.internalReferenceOrdinalOf = internalReferenceOrdinalOf;
const zod_1 = require("zod");
exports.INTERNAL_REFERENCE_ORDINAL_DIGITS = 2;
const LEDGER_KIND_CODES = {
    purchase: 'P',
    sale: 'S',
    costs: 'K',
    overhead: 'O',
};
const DOCUMENT_KIND_CODES = {
    advance: 'ADV',
    provisional: 'PRV',
    final: 'FIN',
    debit_note: 'DN',
    credit_note: 'CN',
    cost: 'CST',
    pro_forma: 'PF',
};
// An ordinal past the padding width prints its full digits rather than truncating: a ledger with a
// hundred documents of one kind is unexpected, and a silently reused reference is worse than a
// wider one.
function padOrdinal(ordinal) {
    return ordinal.toString().padStart(exports.INTERNAL_REFERENCE_ORDINAL_DIGITS, '0');
}
function formatInternalReference(parts) {
    const side = LEDGER_KIND_CODES[parts.ledgerKind];
    const kind = DOCUMENT_KIND_CODES[parts.documentKind];
    return `${parts.orderRef.toString()}-${side}-${kind}${padOrdinal(parts.ordinal)}`;
}
exports.INTERNAL_REFERENCE_PATTERN = /^[1-9]\d*-[PSKO]-(?:ADV|PRV|FIN|DN|CN|CST|PF)(\d{2,})$/;
// A caller may still supply its own reference: interaction principle 4 makes the derived value a
// prefill and the manual entry an audited override. isDerivedInternalReference is what tells the
// two apart for the audit payload.
function isDerivedInternalReference(reference) {
    return exports.INTERNAL_REFERENCE_PATTERN.test(reference);
}
// Reads the ordinal back off a derived reference, so the next one can be drawn above the highest
// live reference rather than off a row count. A count would reissue a live reference once a draft
// below the top is deleted. Answers null for anything this module did not produce.
function internalReferenceOrdinalOf(reference) {
    const match = exports.INTERNAL_REFERENCE_PATTERN.exec(reference);
    if (match === null)
        return null;
    const digits = match[1];
    if (digits === undefined)
        return null;
    const ordinal = Number.parseInt(digits, 10);
    return Number.isSafeInteger(ordinal) ? ordinal : null;
}
exports.INTERNAL_REFERENCE_SOURCES = ['assigned', 'override'];
exports.internalReferenceSourceSchema = zod_1.z.enum(exports.INTERNAL_REFERENCE_SOURCES);
//# sourceMappingURL=internal-reference.js.map